export const calendar = {
  prefix: 'Gw-cl',
  root: 'guest-calendar-widget',
};
